module.exports = __webpack_public_path__ + "static/media/Manguerapremium.f7f37a58.jpg";